import React, { PureComponent } from 'react';
import classNames from 'classnames';
import omit from 'lodash/omit';
import Animate from '../animate';
import addEventListener from '../_util/addEventListener';
import getScroll from '../_util/getScroll';
import scrollTo from '../_util/scrollTo';
import ConfigContext from '../config-provider/ConfigContext';
function getDefaultTarget() {
    return window;
}
export default class BackTop extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            visible: false,
        };
        this.scrollToTop = (e) => {
            const { target = getDefaultTarget, onClick } = this.props;
            scrollTo(0, {
                getContainer: target,
            });
            if (typeof onClick === 'function') {
                onClick(e);
            }
        };
        this.handleScroll = () => {
            const { visibilityHeight, target = getDefaultTarget } = this.props;
            const scrollTop = getScroll(target(), true);
            this.setState({
                visible: scrollTop > visibilityHeight,
            });
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    componentDidMount() {
        const { target = getDefaultTarget } = this.props;
        this.scrollEvent = addEventListener(target(), 'scroll', this.handleScroll);
        this.handleScroll();
    }
    componentWillUnmount() {
        if (this.scrollEvent) {
            this.scrollEvent.remove();
        }
    }
    setScrollTop(value) {
        const { target = getDefaultTarget } = this.props;
        const targetNode = target();
        if (targetNode === window) {
            document.body.scrollTop = value;
            document.documentElement.scrollTop = value;
        }
        else {
            targetNode.scrollTop = value;
        }
    }
    render() {
        const { prefixCls: customizePrefixCls, className = '', visible: propsVisible, children, } = this.props;
        const { getPrefixCls } = this.context;
        const { visible: stateVisible } = this.state;
        const prefixCls = getPrefixCls('back-top', customizePrefixCls);
        const classString = classNames(prefixCls, className);
        const defaultElement = (React.createElement("div", { className: `${prefixCls}-content` },
            React.createElement("div", { className: `${prefixCls}-icon` })));
        // fix https://fb.me/react-unknown-prop
        const divProps = omit(this.props, [
            'prefixCls',
            'className',
            'children',
            'visibilityHeight',
            'target',
            'visible',
        ]);
        const visible = 'visible' in this.props ? propsVisible : stateVisible;
        const backTopBtn = visible ? (React.createElement("div", Object.assign({}, divProps, { className: classString, onClick: this.scrollToTop }), children || defaultElement)) : null;
        return (React.createElement(Animate, { component: "", transitionName: "fade" }, backTopBtn));
    }
}
BackTop.displayName = 'BackTop';
BackTop.defaultProps = {
    visibilityHeight: 400,
};
